import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../apiservices/CasionApi";
import RefResultModal from "../../casinoComponents/refResultModal";
import TrapResultBody from "../../casinoComponents/refResultModal/TrapResultBody";
import { formatRefMatchTime } from "../../../utils/refMatchTime";

/**
 * Last Result items for The Trap in the reference markup (inside .casino-video-last-results):
 * win 1 → span.resulta "A", 2 → span.resultb "B", 0 → "T" (with the reference's " " separators). Click → .loader-overlay while the round detail loads, then
 * the reference result modal ("{ename} Result"). Refetched whenever the round (mid) changes.
 */
export default function TrapRefResults({ gameType = "trap", mid, fallbackTitle = "The Trap" }) {
  const apiType = String(gameType || "trap").toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
  }, [apiType, mid]);

  const handleResultClick = async (rmid) => {
    if (loading || !rmid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(rmid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  return (
    <>
      {lastResults.map((r, i) => {
        const win = String(r?.win);
        const cls = win === "1" ? "resulta" : win === "2" ? "resultb" : undefined;
        return (
          <span key={`${r?.mid}-${i}`} className={cls} onClick={() => handleResultClick(r?.mid)}>
            {win === "1" ? "A" : null} {win === "2" ? "B" : null} {win === "0" ? "T" : null}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
      <RefResultModal
        show={showModal && !!detailResult}
        onHide={() => setShowModal(false)}
        title={`${detailResult?.ename || fallbackTitle} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        {detailResult && <TrapResultBody t1={detailResult} />}
      </RefResultModal>
    </>
  );
}
